// extracted by mini-css-extract-plugin
export default {"mobileGuard":"MobileGuard_mobileGuard__zNQdC","content":"MobileGuard_content__RkK+K","message":"MobileGuard_message__fZJLe"};